import {jQuery as $, lodash as _} from 'lib/shim';
import { BREAKPOINT_DESKTOP, BREAKPOINT_TABLET } from 'defines';




const SELECTOR = '.organism-key-figures';



class OrganismKeyFigures {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$contentWrapper = this._$element.find('.content-wrapper');
			this._maxItemCount = this._$contentWrapper.find('.number-holder').length - 1;

			this._prime();
		}

		return $element;
	}



	_prime() {
		this._$contentWrapper.find('.number-holder').each(function () {
			if ($(this).index() > 1) {
				$(this).addClass('last-item');
			}
		})
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismKeyFigures(app, $this));
	});

	return $elements;
}